import React from 'react';
import { ArrowRight, FileText } from 'lucide-react';

interface HeroProps {
  onChecklistClick: () => void;
}

const Hero: React.FC<HeroProps> = ({ onChecklistClick }) => {
  return (
    <section className="relative w-full pt-28 pb-4 px-4 flex justify-center bg-[#fafafa]">
      <div className="relative w-full max-w-[1440px] h-[85vh] min-h-[650px] flex items-center overflow-hidden bg-zinc-950 rounded-sm shadow-2xl border border-white/5">
        
        {/* Background Image Layer - High Visibility & Clean */}
        <div 
          className="absolute inset-0 bg-cover bg-center opacity-70"
          style={{ 
            backgroundImage: 'url("https://89c7958b302f88270774a4221a06006e.cdn.bubble.io/f1768841734250x897111574655008500/Untitled%20%281920%20x%201080%20px%29.png")',
            backgroundBlendMode: 'luminosity'
          }}
        />
        
        {/* Intentional lack of dark gradient overlays per request for raw visual clarity */}

        {/* Content Container */}
        <div className="relative w-full px-6 md:px-20 z-10">
          <div className="max-w-5xl">
            {/* Main Headline */}
            <h1 className="text-5xl md:text-[6.5rem] lg:text-[7.2rem] font-bold text-white mb-10 leading-[0.95] tracking-tighter">
              We turn African mines into <br />
              <span className="bg-[linear-gradient(to_right,#D4AF37_0%,#F7E08A_20%,#FFF9E3_40%,#FFFFFF_50%,#FFF9E3_60%,#F7E08A_80%,#D4AF37_100%)] bg-clip-text text-transparent animate-gold-shimmer">
                investable
              </span> assets.
            </h1>

            {/* Simplified Subtext */}
            <p className="text-zinc-100 text-base md:text-xl mb-12 max-w-2xl leading-relaxed font-light drop-shadow-lg">
              Helping high-potential operations bridge the gap between geological reality and institutional credibility.
            </p>

            {/* Call to Action Grid - Gold Effect Button */}
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-5">
              <a 
                href="https://wa.me/27839287731"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-3 md:gap-4 bg-[linear-gradient(to_right,#D4AF37_0%,#F7E08A_20%,#FFF9E3_40%,#FFFFFF_50%,#FFF9E3_60%,#F7E08A_80%,#D4AF37_100%)] animate-gold-shimmer text-zinc-950 px-6 md:px-10 py-4 md:py-5 rounded-sm font-black text-[11px] md:text-[13px] uppercase tracking-[0.1em] md:tracking-[0.2em] hover:brightness-110 transition-all shadow-[0_20px_40px_rgba(0,0,0,0.4)] border-none group whitespace-nowrap"
              >
                Book a Strategy Call
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </a>
              
              <button 
                onClick={onChecklistClick}
                className="flex items-center justify-center gap-3 md:gap-4 bg-white/10 backdrop-blur-md text-white px-6 md:px-10 py-4 md:py-5 rounded-sm font-bold text-[11px] md:text-[13px] uppercase tracking-[0.1em] md:tracking-[0.2em] hover:bg-white/20 transition-all shadow-xl border border-white/10 whitespace-nowrap cursor-pointer"
              >
                <FileText className="w-4 h-4 text-[#D4AF37]" />
                Readiness Checklist
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;